import { createSlice } from '@reduxjs/toolkit';
import { getDashboardFilterRequestBody } from 'helper/utils';

const dashboardFilterSlice = createSlice({
  name: 'dashboardFilterSlice',
  initialState: {
    viewTypeSelected: '',
    siteSelected: 'All',
    ciSelected: 'All'
  },
  reducers: {
    setViewTypeSelectedAction: (state, action) => {
      state.viewTypeSelected = action.payload;
    },
    setSiteSelectedAction: (state, action) => {
      state.siteSelected = action.payload;
    },
    setCiSelectedAction: (state, action) => {
      state.ciSelected = action.payload;
    }
  }
});

export const {
  setViewTypeSelectedAction,
  setSiteSelectedAction,
  setCiSelectedAction
} = dashboardFilterSlice.actions;
export default dashboardFilterSlice.reducer;

export const getViewTypeSelectedSelector = (state) =>
  state?.dashboardFilter.viewTypeSelected;

export const getSiteSelectedSelector = (state) =>
  state?.dashboardFilter.siteSelected;

export const getCiSelectedSelector = (state) =>
  state?.dashboardFilter.ciSelected;

export const getDashboardFilterRequestBodySelector = (state) =>
  getDashboardFilterRequestBody(
    state?.dashboardFilter.siteSelected,
    state?.dashboardFilter.ciSelected
  );
